import { type FC } from "react";
import { MenuItem, Stack, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";
import HowToRegIcon from "@mui/icons-material/HowToReg";

import { useCloseManually } from "../hooks/use-close-manually";

interface ManuallyCloseMenuItemProps {
	readonly internalUniqueId: string;
	readonly closingId: string;
}

export const ManuallyCloseMenuItem: FC<ManuallyCloseMenuItemProps> = ({ internalUniqueId, closingId }) => {
	const { close } = useCloseManually(internalUniqueId, closingId);
	return (
		<MenuItem onClick={close}>
			<Stack gap={1} direction="row" alignItems="center">
				<HowToRegIcon fontSize="small" />
				<Typography variant="body2">
					<FormattedMessage id="Manually close" defaultMessage="Manually close" />
				</Typography>
			</Stack>
		</MenuItem>
	);
};
